export default "__VITE_ASSET__Do8SrblF__"